import request from "@/utils/request";

// 博客文章
export function fetchList(params) {
  return request({
    url: "/cms/blog/cms/cmsList",
    method: "get",
    params: params
  });
}

/** 文章详情  */
export function getArticleInfo(id) {
  return request({
    url: "/cms/blog/cms/detail/" + id,
    method: "get",
  });
}

export function getAddBlogViewsApi(id) {
  return request({
    url: "/cms/blog/cms/addBlogViews/" + id,
    method: "get",
  });
}

export function searchArticle(keywords) {
  return request({
    url: "/web/article/searchArticle",
    method: "get",
    params: {
      keywords: keywords
    }
  });
}

//分类或标签id获取文章
export function queryIdToArticles(params) {
  return request({
    url: "/cms/blog/cms/cmsList",
    method: "get",
    params: params
  });
}

//分类或标签id获取文章
export function queryIdToArticles1(params) {
  return request({
    url: "/cms/blog/cms/cmsList",
    method: "get",
    params: params
  });
}

export function like(id) {
  return request({
    url: "/web/article/articleLike",
    method: "get",
    params: { articleId: id }
  });
}

export function checkSecret(params) {
  return request({
    url: "/web/article/checkSecret",
    method: "get",
    params: params
  });
}

//友链页面请求接口
export function addLink(data) {
  return request({
    url: "/web/friend/add",
    method: "POST",
    data
  });
}

export function fetchFriend() {
  return request({
    url: "/web/friend/list",
    method: "post",
    params: {}
  });
}

export function getWebSiteInfo() {
  return request({
    url: "/site/webconfig/webSiteInfo",
    method: "get",
    params: {}
  });
}

//留言接口
export function addMessage(data) {
  return request({
    url: "/web/message/add",
    method: "post",
    data
  });
}

export function listMessage() {
  return request({
    url: "/cms/message/cms/list",
    method: "get",
    params: {}
  });
}

//添加评论
export function addComment(data) {
  return request({
    url: "/cms/comment/cms/addComment",
    method: "post",
    data
  });
}

//评论列表
export function fetchComments(params) {
  return request({
    url: "/cms/comment/cms/list",
    method: "get",
    params: params
  });
}

//查询回复评论
export function repliesByComId(params) {
  return request({
    url: "/web/comment/repliesByComId",
    method: "get",
    params: params
  });
}

//标签接口全部
export function getTags() {
  return request({
    url: "/cms/blog/cms/detail/",
    method: "get",
    params: {}
  });
}

// 查询某个文章的标签接口
export function getBlogDetail(id) {
  return request({
    url: '/cms/blog/cms/detail/' + praseStrEmpty(id),
    method: 'get',
  })
}
// 转换字符串，undefined,null等转化为""
function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}
//分类接口
export function getCategory() {
  return request({
    url: "/cms/blog/cms/detail/",
    method: "get",
    params: {}
  });
}

// 系列笔记分类接口
export function featchCategoryBook() {
  return request({
    url: "/cms/blog/cms/detail/",
    method: "get",
    params: {}
  });
}

//归档接口
export function getArchive(params) {
  return request({
    url: "/cms/blog/cms/cmsEssayList",
    method: "get",
    params: params
  });
}

//qq登录
export function qqLogin(data) {
  return request({
    url: "/user/login",
    method: "post",
    data
  });
}

//qq退出
export function logout() {
  return request({
    url: "/logout",
    method: "post"
  });
}

//gitee登录
export function gitEELogin(code) {
  return request({
    url: "/user/gitEELogin",
    method: "get",
    params: {
      code: code
    }
  });
}

//微博登录
export function weiboLogin(code) {
  return request({
    url: "/user/weiboLogin",
    method: "get",
    params: {
      code: code
    }
  });
}

//添加访客信息
export function report() {
  return request({
    url: "/web/home/report",
    method: "get",
    params: {}
  });
}

//相册接口
export function getAlbum() {
  return request({
    url: "/site/photoAlbum/cms/list",
    method: "get",
    params: {}
  });
}

export function getPhotos(params) {
  return request({
    url: "/site/photo/cms/listPhotos",
    method: "get",
    params: params
  });
}

export function addFeedback(data) {
  return request({
    url: "/web/feedback/add",
    method: "post",
    data
  });
}

export function sendEmailCode(email) {
  return request({
    url: "/user/sendEmailCode",
    method: "get",
    params: {
      email: email
    }
  });
}

export function bindEmail(data) {
  return request({
    url: "/user/bindEmail",
    method: "post",
    data
  });
}

export function emailRegister(data) {
  return request({
    url: "/user/emailRegister",
    method: "post",
    data
  });
}

// 获取验证码
export function getCodeImg(data) {
  return request({
    url: "/captchaImage",
    method: "get",
    params: data
  });
}

// 邮箱登录
export function emailLogin(data) {
  return request({
    url: "/login",
    method: "post",
    data
  });
}
// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

export function updatePassword(data) {
  return request({
    url: "/user/updatePassword",
    method: "post",
    data
  });
}

export function upload(data) {
  return request({
    url: "/system/user/profile/avatar",
    method: "POST",
    headers: { "Content-Type": "multipart/articles-data" },
    data
  });
}

export function updateUser(data) {
  return request({
    url: "/system/user/profile",
    method: "put",
    data
  });
}

// 查询分类信息列表
export function getCategoryAllApi() {
  return request({
    url: "/site/qcategory/cms/listAll",
    method: "get"
  });
}

// 查询该分类下的问题列表
export function getQuestionAllApi(params) {
  return request({
    url: "/site/question/cms/listAll",
    method: "get",
    params
  });
}

// 查询问题详情
export function getQuestionInfoApi(params) {
  return request({
    url: "/site/question/cms/info",
    method: "get",
    params
  });
}

// 查询分类信息和该分类下的问题列表
export function getCategoryAndQuestionList(cid) {
  return request({
    url: "/site/question/cms/list",
    method: "get",
    params: {
      cid: cid
    }
  });
}
// 问题搜索
export function searchQuestion(keywords) {
  return request({
    url: "/web/question/searchQuestion",
    method: "get",
    params: {
      keywords: keywords
    }
  });
}

// 是否收藏问题
export function favoriteQuestion(data) {
  return request({
    url: "/site/qfavoriter/create",
    method: "post",
    data
  });
}

// 是否收藏问题
export function favoriteQuestionDel(data) {
  return request({
    url: "/site/qfavoriter/remove",
    method: "delete",
    data
  });
}

// 查询收藏问题列表
export function getFavoriteQuestionList(params) {
  return request({
    url: "/site/question/favorites/list",
    method: "get",
    params
  });
}
